"use client";

import { BotpressChat } from "@/components/botpress/botpress-chat";
import { usePathname } from "next/navigation";

/**
 * Global chatbot that loads on all pages but is hidden except on contact page
 * This allows testing the chatbot on any page while keeping the UI clean
 */
export function GlobalChatbot() {
	const pathname = usePathname();

	// Don't show the button on contact page (contact page has its own custom button)
	const isContactPage = pathname === "/contact";

	if (isContactPage) {
		return null;
	}

	// Load Botpress on all other pages but keep the button completely hidden
	return <BotpressChat mode="hidden" />;
}
